import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import { Card, FullBox, Collapse } from 'seagull';
import { WideArrowDownward, SyncLiner24, DangerLiner24 } from 'seagull/icons';
import { useIoContext } from '~/contexts';
import CheckmarkCircle from './CheckmarkIcon.json';
import styles from './StepItemsList.module.scss';
const StepItem = /*#__PURE__*/ React.memo(function StepItem(param) {
    let { title, content, status, isExpanded, onExpand, onComplete } = param;
    const { Lottie } = useIoContext();
    const [hasPlayedCompleted, setHasPlayedCompleted] = useState(status === 'completed');
    useEffect(()=>{
        if (status !== 'completed') setHasPlayedCompleted(false);
    }, [
        status
    ]);
    const shouldAutoplay = status === 'completed' && !hasPlayedCompleted;
    const statusIcon = useMemo(()=>{
        if (status === 'pending') return /*#__PURE__*/ _jsx(SyncLiner24, {});
        if (status === 'error') return /*#__PURE__*/ _jsx(DangerLiner24, {});
        return /*#__PURE__*/ _jsx(Lottie, {
            animationData: CheckmarkCircle,
            loop: false,
            autoplay: shouldAutoplay,
            initialSegment: status === 'initial' ? [
                0,
                0
            ] : hasPlayedCompleted ? [
                24,
                24
            ] : undefined,
            onComplete: ()=>{
                setHasPlayedCompleted(true);
                if (isExpanded) {
                    onComplete();
                }
            },
            style: {
                width: 22,
                height: 22
            }
        }, status);
    }, [
        status,
        shouldAutoplay,
        hasPlayedCompleted,
        isExpanded,
        onComplete
    ]);
    return /*#__PURE__*/ _jsxs(Card, {
        className: styles.stepItemContainer,
        children: [
            /*#__PURE__*/ _jsxs("button", {
                className: styles.stepItemHeader,
                onClick: onExpand,
                disabled: !content,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: styles.stepStatusIcon,
                        children: statusIcon
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: styles.stepItemTitle,
                        children: title
                    }),
                    content && /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.arrowContainer, {
                            [styles.reverseArrow]: isExpanded
                        }),
                        children: /*#__PURE__*/ _jsx(WideArrowDownward, {})
                    })
                ]
            }),
            content && /*#__PURE__*/ _jsx(Collapse, {
                in: isExpanded,
                collapsedSize: 0,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.stepItemContent,
                    children: content
                })
            })
        ]
    });
});
export default function StepItemsList(param) {
    let { steps } = param;
    const [expandedItem, setExpandedItem] = useState();
    const toggleExpandedItem = useCallback((index)=>{
        setExpandedItem((prev)=>prev === index ? undefined : index);
    }, []);
    const handleComplete = useCallback(()=>{
        setExpandedItem(steps.findIndex((step)=>step.status !== 'completed'));
    }, [
        setExpandedItem,
        steps
    ]);
    return /*#__PURE__*/ _jsx(FullBox, {
        flexDirection: "column",
        className: styles.allStepsContainer,
        children: steps.map((item, index)=>/*#__PURE__*/ _jsx(StepItem, _object_spread_props(_object_spread({}, item), {
                isExpanded: expandedItem === index,
                onExpand: ()=>toggleExpandedItem(index),
                onComplete: handleComplete
            }), "stepItem-".concat(index)))
    });
}
